var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchConversionRequests } from '@popup/steem/actions/conversion.actions';
import { WalletInfoSectionItemComponent } from '@popup/steem/pages/app-container/home/wallet-info-section/wallet-info-section-item/wallet-info-section-item.component';
import ActiveAccountUtils from '@popup/steem/utils/active-account.utils';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import React, { useEffect, useState } from 'react';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import AccountUtils from '@popup/steem/utils/account.utils';
const WalletInfoSection = ({ activeAccount, currencyLabels, globalProperties, conversions, fetchConversionRequests, }) => {
    const [delegationAmount, setDelegationAmount] = useState('...');
    const [timeBalance, setTimeBalance] = useState(0);
    const [timeLoading, setTimeLoading] = useState(true);
    const [steemBalance, setSteemBalance] = useState(0);
    const [steemLoading, setSteemLoading] = useState(true);
    const [sbdBalance, setSbdBalance] = useState(0);
    const [sbdLoading, setSbdLoading] = useState(true);
    const [spBalance, setSpBalance] = useState(0);
    const [spLoading, setSpLoading] = useState(true);
    const [hiveBalance, setHiveBalance] = useState(0);
    const [hiveLoading, setHiveLoading] = useState(true);
    const [hbdBalance, setHbdBalance] = useState(0);
    const [hbdLoading, setHbdLoading] = useState(true);
    const [hpBalance, setHpBalance] = useState(0);
    const [hpLoading, setHpLoading] = useState(true);
    const [blurtBalance, setBlurtBalance] = useState(0);
    const [blurtLoading, setBlurtLoading] = useState(true);
    const [bpBalance, setBpBalance] = useState(0);
    const [bpLoading, setBpLoading] = useState(true);
    const [activeChain, setActiveChain] = useState('STEEM');
    /* ---------- CARICA ACTIVE_CHAIN DAL LOCALSTORAGE ---------- */
    useEffect(() => {
        const loadActiveChain = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
                const clean = String(saved || "STEEM").replace(/^"|"$/g, '').trim().toUpperCase();
                if (["STEEM", "HIVE", "BLURT", "TIME"].includes(clean)) {
                    setActiveChain(clean);
                }
            }
            catch (_a) {
                setActiveChain("STEEM");
            }
        });
        loadActiveChain();
        const interval = setInterval(loadActiveChain, 2000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        if (!activeAccount || ActiveAccountUtils.isEmpty(activeAccount))
            return;
        /*
            const delegated = parseFloat(
              activeAccount.account.delegated_vesting_shares.toString().replace(' VESTS', ''),
            );
            const received = parseFloat(
              activeAccount.account.received_vesting_shares.toString().replace(' VESTS', ''),
            );
            const netDelegation = (received - delegated).toFixed(3);
            const delegationSP = FormatUtils.toSP(netDelegation, globalProperties.globals);
            setDelegationAmount(delegationSP);
        */
        const fetchTime = () => __awaiter(void 0, void 0, void 0, function* () {
            setTimeLoading(true);
            try {
                setTimeBalance(yield AccountUtils.getTime(activeAccount.name));
            }
            finally {
                setTimeLoading(false);
            }
        });
        fetchTime();
        const fetchSteem = () => __awaiter(void 0, void 0, void 0, function* () {
            setSteemLoading(true);
            setSbdLoading(true);
            setSpLoading(true);
            try {
                setSteemBalance(yield AccountUtils.getSteem(activeAccount.name));
            }
            finally {
                setSteemLoading(false);
            }
            try {
                setSbdBalance(yield AccountUtils.getSbd(activeAccount.name));
            }
            finally {
                setSbdLoading(false);
            }
            try {
                setSpBalance(yield AccountUtils.getSp(activeAccount.name));
            }
            finally {
                setSpLoading(false);
            }
        });
        fetchSteem();
        const fetchHive = () => __awaiter(void 0, void 0, void 0, function* () {
            setHiveLoading(true);
            setHbdLoading(true);
            setHpLoading(true);
            try {
                setHiveBalance(yield AccountUtils.getHive(activeAccount.name));
            }
            finally {
                setHiveLoading(false);
            }
            try {
                setHbdBalance(yield AccountUtils.getHbd(activeAccount.name));
            }
            finally {
                setHbdLoading(false);
            }
            try {
                setHpBalance(yield AccountUtils.getHp(activeAccount.name));
            }
            finally {
                setHpLoading(false);
            }
        });
        fetchHive();
        const fetchBlurt = () => __awaiter(void 0, void 0, void 0, function* () {
            setBlurtLoading(true);
            setBpLoading(true);
            try {
                setBlurtBalance(yield AccountUtils.getBlurt(activeAccount.name));
            }
            finally {
                setBlurtLoading(false);
            }
            try {
                setBpBalance(yield AccountUtils.getBp(activeAccount.name));
            }
            finally {
                setBpLoading(false);
            }
        });
        fetchBlurt();
        fetchConversionRequests(activeAccount.name);
    }, [activeAccount.name]);
    const renderWalletItems = () => {
        switch (activeChain) {
            case 'STEEM':
                return (React.createElement(React.Fragment, null,
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "STEEM", icon: SVGIcons.WALLET_STEEM_LOGO, mainValue: steemLoading ? '...' : steemBalance, mainValueLabel: currencyLabels.steem }),
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "SBD", icon: SVGIcons.WALLET_SBD_LOGO, mainValue: sbdLoading ? '...' : sbdBalance, mainValueLabel: currencyLabels.sbd }),
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "SP", icon: SVGIcons.WALLET_SP_LOGO, mainValue: spLoading ? '...' : spBalance, mainValueLabel: currencyLabels.sp })));
            case 'HIVE':
                return (React.createElement(React.Fragment, null,
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "HIVE", icon: SVGIcons.WALLET_HIVE_LOGO, mainValue: hiveLoading ? '...' : hiveBalance, mainValueLabel: currencyLabels.hive }),
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "HBD", icon: SVGIcons.WALLET_HBD_LOGO, mainValue: hbdLoading ? '...' : hbdBalance, mainValueLabel: currencyLabels.hbd }),
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "HP", icon: SVGIcons.WALLET_HP_LOGO, mainValue: hpLoading ? '...' : hpBalance, mainValueLabel: currencyLabels.hp })));
            case 'BLURT':
                return (React.createElement(React.Fragment, null,
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "BLURT", icon: SVGIcons.WALLET_BLURT_LOGO, mainValue: blurtLoading ? '...' : blurtBalance, mainValueLabel: currencyLabels.blurt }),
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "BP", icon: SVGIcons.WALLET_BP_LOGO, mainValue: bpLoading ? '...' : bpBalance, mainValueLabel: currencyLabels.bp })));
            case 'TIME':
                return (React.createElement(React.Fragment, null,
                    React.createElement(WalletInfoSectionItemComponent, { tokenSymbol: "TIME", icon: SVGIcons.WALLET_TIME_LOGO, mainValue: timeLoading ? '...' : timeBalance, mainValueLabel: currencyLabels.time })));
            default:
                return null;
        }
    };
    return (React.createElement("div", { className: "wallet-info-wrapper" },
        React.createElement("div", { className: "wallet-background" }),
        React.createElement("div", { className: "wallet-info-section" }, renderWalletItems())));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        activeAccount: state.steem.activeAccount,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        globalProperties: state.steem.globalProperties,
        conversions: state.steem.conversions,
    };
};
const connector = connect(mapStateToProps, {
    fetchConversionRequests,
});
export const WalletInfoSectionComponent = connector(WalletInfoSection);
